import { useQuery } from '@tanstack/react-query';
import { getClientAccount } from '../../../api/SageAdmin/ClientAccount';
import type { IGetClientAccountServiceRes } from '../../../api/SageAdmin/ClientAccount/types';
import { ReactQueryKey } from '../../../constants/ReactQueryKeys';
import type { QueryParamsInterface } from '../../../types/Shared';

interface IClientAccountHookProps {
  accountId: number;
  params?: QueryParamsInterface;
  onSuccess?: (data: IGetClientAccountServiceRes) => void;
  onError?: (error: unknown) => void;
  enabled?: boolean;
}

const useClientAccount = ({ accountId, params, onSuccess, onError, enabled = true }: IClientAccountHookProps) => {
  return useQuery<IGetClientAccountServiceRes, unknown>({
    queryKey: [ReactQueryKey.GET_CLIENT_ACCOUNT, params, accountId],
    queryFn: () => getClientAccount({ accountId, params }),
    onSuccess,
    onError,
    enabled: enabled && Number.isInteger(accountId) && accountId > 0,
  });
};

export default useClientAccount;
